import { SET_MOBILE_STATE } from "app/action_types/is_user_on_mobile_device_action_types";

export const setIsUserOnMobileDeviceMobileState = (isMobile: boolean) => ({
    type: SET_MOBILE_STATE,
    isMobile,
});
